export default __webpack_public_path__ + "images/SKYALPS.d131c6d.png";